export default __webpack_public_path__ + "static/media/location_footer_landing_page.2ef5c022.svg";